// Copyright (c) 2018 Deere & Company

export default Object.freeze({
    ADD_REQUEST_DETAILS_INFO_REQUEST_FORM_FILE: 'ADD_REQUEST_DETAILS_INFO_REQUEST_FORM_FILE',
    ADD_REQUEST_DETAILS_PICT_REQUEST_FORM_FILE: 'ADD_REQUEST_DETAILS_PICT_REQUEST_FORM_FILE',
    DELETE_REQUEST_DETAILS_INFO_REQUEST_FORM_FILE: 'DELETE_REQUEST_DETAILS_INFO_REQUEST_FORM_FILE',
    RESET_FORM_IS_DIRTY_TO_FALSE: 'RESET_FORM_IS_DIRTY_TO_FALSE',
    RESET_REQUEST_DETAILS: 'RESET_REQUEST_DETAILS',
    UPDATE_REQUEST_DETAILS_INFO_REQUEST_FORM: 'UPDATE_REQUEST_DETAILS_INFO_REQUEST_FORM',
    UPDATE_REQUEST_DETAILS_INFO_REQUEST_FORM_ANSWER: 'UPDATE_REQUEST_DETAILS_INFO_REQUEST_FORM_ANSWER',
    UPDATE_REQUEST_DETAILS_INFO_REQUEST_FORM_COMMENTS: 'UPDATE_REQUEST_DETAILS_INFO_REQUEST_FORM_COMMENTS',
    UPDATE_REQUEST_DETAILS_INFO_REQUEST_FORM_FILE: 'UPDATE_REQUEST_DETAILS_INFO_REQUEST_FORM_FILE',
    UPDATE_REQUEST_DETAILS_INFO_REQUEST_FORM_RETURN_STATUS: 'UPDATE_REQUEST_DETAILS_INFO_REQUEST_FORM_RETURN_STATUS',
    UPDATE_REQUEST_DETAILS_PART_REQUEST_FORM: 'UPDATE_REQUEST_DETAILS_PART_REQUEST_FORM',
    UPDATE_REQUEST_DETAILS_PART_REQUEST_FORM_COMMENTS: 'UPDATE_REQUEST_DETAILS_PART_REQUEST_FORM_COMMENTS',
    UPDATE_REQUEST_DETAILS_PART_REQUEST_FORM_COURIER_NAME: 'UPDATE_REQUEST_DETAILS_PART_REQUEST_FORM_COURIER_NAME',
    UPDATE_REQUEST_DETAILS_PART_REQUEST_FORM_DISPATCH_DATE: 'UPDATE_REQUEST_DETAILS_PART_REQUEST_FORM_DISPATCH_DATE',
    UPDATE_REQUEST_DETAILS_PART_REQUEST_FORM_RETURN_STATUS: 'UPDATE_REQUEST_DETAILS_PART_REQUEST_FORM_RETURN_STATUS',
    UPDATE_REQUEST_DETAILS_PART_REQUEST_FORM_TRACKING_NUMBER: 'UPDATE_REQUEST_DETAILS_PART_REQUEST_FORM_TRACKING_NUMBER',
    UPDATE_REQUEST_DETAILS_PART_RETURN: 'UPDATE_REQUEST_DETAILS_PART_RETURN',
    UPDATE_REQUEST_DETAILS_PICT_REQUEST_FORM: 'UPDATE_REQUEST_DETAILS_PICT_REQUEST_FORM',
    UPDATE_REQUEST_DETAILS_PICT_REQUEST_FORM_COMMENTS: 'UPDATE_REQUEST_DETAILS_PICT_REQUEST_FORM_COMMENTS',
    UPDATE_REQUEST_DETAILS_PICT_REQUEST_FORM_FILE: 'UPDATE_REQUEST_DETAILS_PICT_REQUEST_FORM_FILE',
    UPDATE_REQUEST_DETAILS_PICT_REQUEST_FORM_RETURN_STATUS: 'UPDATE_REQUEST_DETAILS_PICT_REQUEST_FORM_RETURN_STATUS'
});



// WEBPACK FOOTER //
// ./src/part-requests/request-details/actions-list.js